import Link from '@/components/Link';
import TrainerSingleLayout from './TrainerSingleLayout';
import TrainerSidebar from './TrainerSidebar';
import TrainerCard from './TrainerCard';
import TrainerContent from './TrainerContent';
import TrainerCertifications from './TrainerCertifications';
import TrainerTrainings from './TrainerTrainings';

export default function Trainer({ trainer }) {
  const hasCertifications = trainer.info?.certifications !== null;
  const hasTrainings = trainer.info?.trainings !== null;

  return (
    <TrainerSingleLayout
      sidebar={
        <TrainerSidebar>
          <TrainerCard {...trainer} />
        </TrainerSidebar>
      }
    >
      <div className="space-y-6 lg:space-y-10 divide-y-2">
        <div className="space-y-6 pt-8">
          <Link
            className="inline-flex items-center space-x-2 font-semibold text-green-500 text-lg"
            href="/entrenadores"
          >
            <svg
              className="w-4 h-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
                clipRule="evenodd"
              />
            </svg>
            <div>Volver al listado de entrenadores</div>
          </Link>
          <h1 className="text-xl lg:text-4xl xl:text-5xl font-semibold lg:font-extrabold">
            {trainer.title}
          </h1>
          <TrainerContent content={trainer.content} />
        </div>
        {hasCertifications && (
          <div className="pt-6 lg:pt-10">
            <TrainerCertifications
              certifications={trainer.info.certifications}
            />
          </div>
        )}
        {hasTrainings && (
          <div className="pt-6 lg:pt-10">
            <TrainerTrainings trainings={trainer.info.trainings} />
          </div>
        )}
      </div>
    </TrainerSingleLayout>
  );
}
